export enum ApiKeyEnvironmentTypes {
  test = 'test',
  live = 'live',
}

export enum ApiKeyTypes {
  secret = 'secret',
  publishable = 'publishable',
}
